import { Paper } from "@mui/material";
import { AbstractTypedDataForm } from "../../components/data/DataForm";
import { FormTextInput } from "../../components/form/TextInput";
import { Notification } from "../../models/Types";
import { isMobile } from "../../utils";

export function notificationParse(d?: any) {
    const dto = (d || {}) as Notification;
	d?.CreateDate && (dto.CreateDate = new Date(d.CreateDate));
	dto.HashTags || (dto.HashTags = []);
    return dto;
}

export class NotificationForm extends AbstractTypedDataForm<Notification, {}, { tags: string[] }> {
	protected getTypeId(): string {
		return 'Notification';
	}

	protected getTypeName(): React.ReactNode {
		return 'Уведомление';
	}

	buildButtons() {
		return [];
	}

	protected createEntity() {
		return NotificationParse();
	}

	protected buildItems(entity?: Notification | undefined): React.ReactNode {
		return <>
			<Paper sx={isMobile() ? { flex: 1 } : { minWidth: 500, minHeight: 350 }}>
				<FormTextInput label="Заголовок" name="Name" form={this} entity={entity} inputProps={{ disabled: true }} />
			</Paper>
		</>;
	}
}